<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dl [columns]="{ sm: 1, md: 2 }" [rowGap]="'xl'">
    <fudis-dl-item *ngIf="courseUnitRealisation.teachingLanguageUrn | codeLocalizedName | async as teachingLanguage">
      <fudis-dt [contentText]="t('FIELD_NAMES.teachingLanguageUrn')" />
      <fudis-dd [contentText]="teachingLanguage" />
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.studyFormat as studyFormat">
      <fudis-dt [contentText]="t('COURSE_UNIT_REALISATION_INFO.STUDY_FORMAT')" />
      <fudis-dd>
        <sis-localized-markup-string-view [content]="studyFormat" />
      </fudis-dd>
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.learningEnvironments?.length > 0">
      <fudis-dt [contentText]="t('FIELD_NAMES.learningEnvironments')" />
      <fudis-dd>
        <p *ngIf="courseUnitRealisation.learningEnvironmentDescription">{{
          courseUnitRealisation.learningEnvironmentDescription | localizedString
        }}</p>
        @for (learningEnvironment of courseUnitRealisation.learningEnvironments; track $index) {
          <a fudisLink [title]="learningEnvironment.name" [external]="true" [href]="learningEnvironment.url"></a>
        }
      </fudis-dd>
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.learningMaterial as learningMaterial">
      <fudis-dt [contentText]="t('FIELD_NAMES.learningMaterial')" />
      <fudis-dd><sis-localized-markup-string-view [content]="learningMaterial" /></fudis-dd>
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.customCodeUrns as customCodeUrns">
      <fudis-dt [contentText]="t('CUSTOM_CODE_VALUES.TITLE')" />
      <fudis-dd>
        <sis-custom-code-urns [codeUrnsMap]="customCodeUrns" [classificationScope]="'course-unit-realisation'" />
      </fudis-dd>
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.literature?.length > 0">
      <fudis-dt [contentText]="t('FIELD_NAMES.literature')" />
      <fudis-dd>
        <sis-literature *ngFor="let literature of courseUnitRealisation.literature" [literature]="literature" />
      </fudis-dd>
    </fudis-dl-item>
    <fudis-dl-item *ngIf="courseUnitRealisation.additionalInfo as additionalInfo">
      <fudis-dt [contentText]="t('FIELD_NAMES.additionalInfo')" />
      <fudis-dd><sis-localized-markup-string-view [content]="additionalInfo" /></fudis-dd>
    </fudis-dl-item>
    <ng-container *ngIf="alternativeCourseUnits$ | async as alternativeCourseUnits">
      <fudis-dl-item *ngIf="alternativeCourseUnits?.length > 0">
        <fudis-dt [contentText]="t('COURSE_UNIT_REALISATION_INFO.ALTERNATIVE_COURSE_UNITS')" />
        <fudis-dd>
          <p class="sis-guidance">{{ t("COURSE_UNIT_REALISATION_INFO.ALTERNATIVE_CU_HELP") }}</p>
          @for (courseUnit of alternativeCourseUnits; track courseUnit.id) {
            <span
              >{{ courseUnit.code }} {{ courseUnit.name | localizedString }} /
              @if (assessmentItemsByCourseUnitId$ | async; as assessmentItemsByCourseUnitId) {
                @for (assessmentItem of assessmentItemsByCourseUnitId.get(courseUnit.id); track assessmentItem.id) {
                  <span>{{ assessmentItem.name | localizedString }}</span
                  ><span> ({{ assessmentItem.credits | creditRange }}</span
                  >){{ $last ? "" : ", " }}
                }
              }
            </span>
          }
        </fudis-dd>
      </fudis-dl-item>
    </ng-container>
    <fudis-dl-item *ngIf="courseUnitRealisation.responsibilityInfos?.length > 0">
      <fudis-dt [contentText]="t('FIELD_NAMES.responsibilityInfos')" />
      <fudis-dd>
        <sis-responsibility-infos
          [responsibilityInfos]="courseUnitRealisation.responsibilityInfos"
          [roleVisibilityAndOrder]="[
            'urn:code:course-unit-realisation-responsibility-info-type:contact-info',
            'urn:code:course-unit-realisation-responsibility-info-type:responsible-teacher',
            'urn:code:course-unit-realisation-responsibility-info-type:teacher',
          ]">
        </sis-responsibility-infos>
      </fudis-dd>
    </fudis-dl-item>
  </fudis-dl>
  <div *ngIf="courseUnitRealisation.organisations?.length > 0" class="form-group-mimic mt-5">
    <sis-organisation-role-share
      [organisations]="courseUnitRealisation.organisations"
      [organisationRoleUrn]="'urn:code:organisation-role:responsible-organisation'"></sis-organisation-role-share>

    <sis-organisation-role-share
      *ngIf="hasCoordinatingOrganisations()"
      [organisations]="courseUnitRealisation.organisations"
      [organisationRoleUrn]="'urn:code:organisation-role:coordinating-organisation'"></sis-organisation-role-share>
  </div>
</ng-container>
